<template>
  <div class="app-layout d-flex flex-column" :class="{'sidebar-hidden': !sidebarVisible, 'sidebar-visibe': sidebarVisible, 'user-authenticated': authenticated, 'user-not-authenticated': !authenticated }">
    <navbar v-on:toggle-sidebar="toggleSidebar"></navbar>
    <div class="container-fluid col h-100" id="content">
      <div class="row h-100">
        <vue-perfect-scrollbar>
          <sidebar :visible="sidebarVisible" v-if="authenticated"></sidebar>
        </vue-perfect-scrollbar>
        <div class="col mw-25">
          <!--<vue-perfect-scrollbar>-->
            <div class="p-4 mb-3 min-vh-80">
              <o-child/>
            </div>
          <!--</vue-perfect-scrollbar>-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  #content {
    padding-top: 56px;
  }
</style>

<script>
  import Navbar from '~/components/Navbar'
  import Sidebar from '~/components/Sidebar'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {mapGetters} from 'vuex'

  export default {
    name: 'app-layout',

    data: () => ({
      sidebarVisible: true
    }),

    computed: {
      ...mapGetters({
        authenticated: 'auth/check'
      }),
      containerClasses() {
        return ''
        if (this.authenticated) {
          return 'col-sm-12 ml-sm-auto col-md-8 col-lg-9 col-xl-9 pt-0'
        }
        return 'col-sm-12 mx-sm-auto col-md-12 col-lg-10 col-xl-8 pt-0'
      }
    },

    mounted() {
      this.sidebarVisible = window.innerWidth > 768
    },

    components: {
      Navbar,
      Sidebar,
      VuePerfectScrollbar
    },

    methods: {
      toggleSidebar() {
        this.sidebarVisible = !this.sidebarVisible
      }
    }
  }
</script>
